<template>
  <v-card class="mb-4">
    <v-card-title>Andamento prenotazioni per data</v-card-title>
    <v-card-text>
      <apexchart
          type="line"
          height="350"
          :options="chartOptions"
          :series="chartSeries"
      />
    </v-card-text>
  </v-card>
</template>


<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'ReservationByDate',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    filters: Object
  },
  data() {
    return {
      chartSeries: [],
      chartOptions: {
        chart: {
          id: 'reservation-line-chart',
          zoom: { enabled: true },
          toolbar: { show: true }
        },
        xaxis: {
          type: 'datetime',
          title: { text: 'Data' },
          labels: {
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM 'yy",
              day: 'dd MMM'
            }
          }
        },
        yaxis: {
          title: { text: 'Prenotazioni' },
          min: 0
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        tooltip: {
          x: { format: 'dd MMM yyyy' }
        },
        markers: {
          size: 4
        }
      }
    };
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler(newFilters) {
        this.fetchData(newFilters);
      }
    }
  },
  methods: {
    async fetchData(filters) {
      const data = await this.$store.dispatch('analytics/getReservationsByDate', filters);
      this.chartSeries = [
        {
          name: 'Prenotazioni',
          data: data.map(item => [new Date(item.date).getTime(), item.count])
        }
      ];
    }
  }
};
</script>
